import {useSortable} from '@dnd-kit/react/sortable'
import {SortableKeyboardPlugin} from '@dnd-kit/dom/sortable'

export const useCatalogSortable = ({id, parentId = null, index, disabled}) => {
  const type = JSON.stringify(['catalog-order', parentId])
  return useSortable({
    id: JSON.stringify([parentId, id]),
    index,
    group: type,
    type,
    accept: type,
    data: {itemId: id, parentId},
    disabled,
    plugins: [SortableKeyboardPlugin],
  })
}
